import Vue from 'vue'

Vue.prototype.Root = $_____ROOT_____$;
Vue.prototype.Apis = {
    getMyJdForTheCourse: {
        url: 'getMyJdForTheCourse',
        type: 'get',
        comment: '获取用户关于这门课程的最近课时',
        data: {
            cid: '课程id',
            type: '课程类型'
        }
    },

    getCourseOrder: {
        url: 'getCourseOrder',
        type: 'get',
        comment: '首页数据',
    },
    GetCourseCoupon: {
        url: 'GetCourseCoupon',
        type: 'get',
        comment: '优惠券',
    },

    MyComments: {
        url: 'MyComments',
        type: 'get',
        comment: '我的评价',
    },

    MyCollection: {
        url: 'MyCollection',
        type: 'get',
        comment: '我的收藏',
    },

    CourseOrderRefund: {
        url: 'CourseOrderRefund',
        type: 'get',
        comment: '售后退费',
    },

    get_teacher_details: {
        url: 'get_teacher_details',
        type: 'get',
        comment: '教师详情',
    },

    get_course_about_teacher_list: {
        url: 'get_course_about_teacher_list',
        type: 'get',
        comment: '教师课程',
    },

    TeacherLove: {
        url: 'TeacherLove',
        type: 'post',
        comment: '教师点赞',
    },

    TeacherComment: {
        url: 'TeacherComment',
        type: 'post',
        comment: '教师评论',
    },

    GetCourseTeacherCommentList: {
        url: 'GetCourseTeacherCommentList',
        type: 'get',
        comment: '获取教师评论列表',
    },

    TeacherLeaveList: {
        url: 'TeacherLeaveList',
        type: 'get',
        comment: '获取教师留言',
    },

    TeacherCollection: {
        url: 'TeacherCollection',
        type: 'post',
        comment: '教师收藏',
    },

    TeacherLeave: {
        url: 'TeacherLeave',
        type: 'post',
        comment: '教师留言',
    },

// -----课程------


    exchange_code: {
        url: 'exchange_code',
        type: 'post',
        comment: '课程码开通课程',
        data: {
            code: '课程码',
        }
    },

    getClassifyList: {
        url: 'getClassifyList',
        type: 'get',
        comment: '获取分类',
        data: {
            cid: '分类父级ID'
        }
    },
    bindClassify: {
        url: 'bindClassify',
        type: 'post',
        comment: '获取分类',
        data: {
            cid: '分类ID',
        }
    },
    getMyBindClassifyList: {
        url: 'getMyBindClassifyList',
        type: 'get',
        comment: '获取用户绑定的分类',
        data: {}
    },
    getLastClassify: {
        url: 'getLastClassify',
        type: 'get',
        comment: '获取最后一级分类',
        data: {
            cid: '分类ID'
        }
    },
    updateUserSelectClassify: {
        url: 'updateUserSelectClassify',
        type: 'post',
        comment: '更新用户当前选择的分类',
        data: {
            cid: '分类ID'
        }
    },
    getChapter: {
        url: 'getChapter',
        type: 'get',
        comment: '更新用户当前选择的分类',
        data: {
            cid: '分类ID',
            pid: '父级ID'
        }
    },
    getUserForQuestionBankData: {
        url: 'getUserForQuestionBankData',
        type: 'get',
        comment: '获取题库首页其他信息',
        data: {
            cid: '分类ID'
        }
    },
    getPaperList: {
        url: 'getPaperList',
        type: 'get',
        comment: '获取对应分类试卷列表',
        data: {
            cid: '分类ID',
            type: '试卷分类'
        }
    },

    getPaperIndex: {
        url: 'getPaperIndex',
        type: 'get',
        comment: '获取试卷详情',
        data: {
            paperId: '试卷ID',
        }
    },
    getQuestionList: {
        url: 'getQuestionList',
        type: 'get',
        comment: '获取题目列表',
        data: {
            type: '入口类型',
            paperId: '试卷ID',
            cp_id: '分类ID',
        }
    },
    saveQuestionAnswer: {
        url: 'saveQuestionAnswer',
        type: 'post',
        comment: '保存题目答案',
        data: {
            answer: '题目和答案数据',
            sid: '试卷ID',
            in_chapter: '是否为章节练习',
        }
    },
    saveQuestionCollect: {
        url: 'saveQuestionCollect',
        type: 'post',
        comment: '添加收藏题目',
        data: {
            uid: '用户ID',
            qid: '题目ID',
        }
    },
    delQuestionCollect: {
        url: 'delQuestionCollect',
        type: 'post',
        comment: '添加收藏题目',
        data: {
            uid: '用户ID',
            qid: '题目ID',
        }
    },

// -----课程------
    getIndexCate: {
        url: 'getIndexCate',
        type: 'get',
        comment: '获取首页分类',
        data: {
            type: '获取分类类型',
        }
    },
    getCourseList: {
        url: 'getCourseList',
        type: 'get',
        comment: '获取课程列表',
        data: {
            type: '类型',
            cid: '分类ID'
        }
    },

    getCourseDetail: {
        url: 'getCourseDetail',
        type: 'get',
        comment: '获取课程详情',
        data: {
            type: '类型',
            cid: '课程ID'
        }
    },
    smsLogin: {
        url: 'smsLogin',
        type: 'post',
        comment: '获取课程详情',
        data: {}
    },
    getCourseTeacher: {
        url: 'getCourseTeacher',
        type: 'get',
        comment: '获取课程详情授课教师',
        data: {
            type: '类型',
            cid: '课程ID'
        }
    },
    getCourseAboutCourse: {
        url: 'getCourseAboutCourse',
        type: 'get',
        comment: '获取课程详情关联课程',
        data: {
            type: '类型',
            cid: '课程ID'
        }
    },
    getCoursePr: {
        url: 'getCoursePr',
        type: 'get',
        comment: '获取课程详情课时',
        data: {
            type: '类型',
            cid: '课程ID'
        }
    },
    getCcVideoUserInfo: {
        url: 'getCcVideoUserInfo',
        type: 'get',
        comment: '获取课程配置',
        data: {
            key: '别名',
        }
    },

    getCoursePrDetail: {
        url: 'getCoursePrDetail',
        type: 'get',
        comment: '获取课时详情',
        data: {
            type: '类型',
            cid: '课程ID',
            CourseId: '课时ID'
        }
    },

    getLiveRoomInfo: {
        url: 'getLiveRoomInfo',
        type: 'get',
        comment: '获取直播房间信息',
        data: {
            type: '类型',
            cid: '课程ID',
            CourseId: '课时ID'
        }
    },

    getNowAndNextLive: {
        url: 'getNowAndNextLive',
        type: 'get',
        comment: '获取当前直播和下期直播',
        data: {
            type: '类型',
            cid: '课程ID',
            CourseId: '课时ID'
        }
    },

    saveCourseCollect: {
        url: 'saveCourseCollect',
        type: 'get',
        comment: '收藏课程',
        data: {
            type: '类型',
            cid: '课程ID',
            CourseId: '课时ID'
        }
    },

    deleteCourseCollect: {
        url: 'deleteCourseCollect',
        type: 'get',
        comment: '取消收藏课程',
        data: {
            type: '类型',
            cid: '课程ID',
            CourseId: '课时ID'
        }
    },

    getCourseAboutMaterial: {
        url: 'getCourseAboutMaterial',
        type: 'get',
        comment: '获取课程资料',
        data: {
            type: '类型',
            cid: '课程ID',
            CourseId: '课时ID'
        }
    },

    setUserStudyJdForLiveCourse: {
        url: 'setUserStudyJdForLiveCourse',
        type: 'post',
        comment: '保存直播课程进度',
        data: {
            type: '类型',
            cid: '课程ID',
            CourseId: '课时ID'
        }
    },

    setUserStudyJdForOnlineCourse: {
        url: 'setUserStudyJdForOnlineCourse',
        type: 'post',
        comment: '保存点播课程进度',
        data: {
            type: '类型',
            cid: '课程ID',
            CourseId: '课时ID'
        }
    },


    getCourseAboutComment: {
        url: 'getCourseAboutComment',
        type: 'get',
        comment: '获取课程评论',
        data: {
            type: '类型',
            cid: '课程ID',
            CourseId: '课时ID'
        }
    },
    getUserMoney: {
        url: 'getUserMoney',
        type: 'get',
        comment: '获取用户余额',
        data: {}
    },

    getVoucherDetail: {
        url: 'getVoucherDetail',
        type: 'get',
        comment: '获取抵用券详情',
        data: {
            voucher: '抵用券码'
        }
    },

    getPayAppId: {
        url: 'getPayAppId',
        type: 'get',
        comment: '获取用于支付的公众号AppId',
        data: {}
    },

    getPayOpenId: {
        url: 'getPayOpenId',
        type: 'get',
        comment: '获取用于支付的用户OpenID',
        data: {
            code: '授权Code'
        }
    },
    getUserJsSdkConfig: {
        url: 'getUserJsSdkConfig',
        type: 'get',
        comment: '获取JSSDK初始化配置',
        data: {
            url: '当前页面url'
        }
    },
    getPayJsSdkConfig: {
        url: 'getPayJsSdkConfig',
        type: 'get',
        comment: '获取JSSDK初始化配置',
        data: {
            url: '当前页面url'
        }
    },
    loadPayJsSdkConfig: {
        url: 'loadPayJsSdkConfig',
        type: 'get',
        comment: '获取JSSDK初始化配置',
        data: {
            url: '当前页面url'
        }
    },
    createCourseOrder: {
        url: 'createCourseOrder',
        type: 'get',
        comment: '创建订单并支付',
        data: {
            code: '授权Code'
        }
    },


    getMarket: {
        url: 'getMarket',
        type: 'get',
        comment: '获取营销配置',
        data: {}
    },

    courseTransmitEarnings: {
        url: 'courseTransmitEarnings',
        type: 'post',
        comment: '达成课程转发收益',
        data: {
            shareid: '推荐人ID',
            type: '课程类型',
            cid: '课程ID'
        }
    },

    CheckIfCanOpenTheCourseDirectly: {
        url: 'CheckIfCanOpenTheCourseDirectly',
        type: 'get',
        comment: '查询当前课程我是否能直接开通',
        data: {
            type: '课程类型',
            cid: '课程ID'
        }
    },

    CheckIfCanAutoOpenTheCourseDirectly: {
        url: 'CheckIfCanAutoOpenTheCourseDirectly',
        type: 'get',
        comment: '查询当前课程我是否能自动开通',
        data: {}
    },

    getMyCourse: {
        url: 'getMyCourse',
        type: 'get',
        comment: '个人中心-我的课程列表',
        data: {
            type: '[1：点播,2直播，3：面授]'
        }
    },

    getMyVip: {
        url: 'getMyVip',
        type: 'get',
        comment: '个人中心-我的课程-vip分类',
    },

    openTheCourse: {
        url: 'openTheCourse',
        type: 'post',
        comment: '开通我的课程',
        data: {
            type: '[1：点播,2直播，3：面授]',
            cid: '课程ID'
        }
    },

    addCourseFocus: {
        url: 'addCourseFocus',
        type: 'post',
        comment: '添加关注',
        data: {
            type: '[1：点播,2直播，3：面授]',
            cid: '课程ID'
        }
    },


//#--------------Public-------------------------
    getWebSite: {
        url: 'getWebSite',
        type: 'get',
        comment: '获取网站基本配置',
        data: {}
    },
    getUserInfo: {
        url: 'getUserInfo',
        type: 'get',
        comment: '获取用户信息',
        data: {}
    },
//#--------------Public-end---------------------

//#--------------Login-------------------------

    login: {
        url: 'login',
        type: 'get',
        comment: '用户手机号登录',
        data: {
            username: '账号',
            password: '密码'
        }
    },
    getUserAccessToken: {
        url: 'getUserAccessToken',
        type: 'post',
        comment: '用户微信登录',
        data: {
            code: '授权码',
        }
    },
    regSendCode: {
        url: 'regSendCode',
        type: 'post',
        comment: '用户获取注册验证码',
        data: {
            phone: '手机号',
        }
    },
    reg: {
        url: 'reg',
        type: 'post',
        comment: '用户获取注册验证码',
        data: {
            phone: '手机号',
            code: '验证码',
            password: '密码',
        }
    },
//#--------------My-------------------------

    sendCodeToBindPhone: {
        url: 'sendCodeToBindPhone',
        type: 'post',
        comment: '用户获取绑定手机验证码',
        data: {
            phone: '手机号',
        }
    },
    UserBindPhone: {
        url: 'UserBindPhone',
        type: 'post',
        comment: '用户获取绑定手机',
        data: {
            phone: '手机号',
            code: '验证码'
        }
    },
    extensionCourse: {
        url: 'user/coursePro',
        type: 'post',
        comment: 'extensionCourse',
    },

    orderCount: {
        url: 'user/courseCount',
        type: 'post',
        comment: 'orderCount',
    },

    courseList: {
        url: 'user/courseList',
        type: 'post',
        comment: 'courseList',
    },
    event: {
        url: 'event/event',
        type: 'post',
        comment: 'event',
    },

    promotion: {
        url: 'event/myPromotion',
        type: 'post',
        comment: 'myPromotion',
    },

    distribution: {
        url: 'event/distribution',
        type: 'post',
        comment: 'distribution',
    },

    eventInfo: {
        url: 'event/eventInfo',
        type: 'post',
        comment: 'eventInfo',
    },

    myEvent: {
        url: 'event/myEvent',
        type: 'post',
        comment: 'myEvent',
    },

    eventUser: {
        url: 'event/myEvent',
        type: 'post',
        comment: 'myEvent',
    },

    getArticleDetail: {
        url: 'getArticleDetail',
        type: 'get',
        comment: '文章详情',
    },

    getArticleComment: {
        url: 'getArticleComment',
        type: 'get',
        comment: '文章评论列表',
    },

    sendArticleComment: {
        url: 'sendArticleComment',
        type: 'post',
        comment: '评论文章',
    },

    randArticle: {
        url: 'article/randArticle',
        type: 'post',
        comment: 'randArticle',
    },
    articleCate: {
        url: 'login/articleCate',
        type: 'get',
        comment: 'articleCate',
    },
    getArticleCateList: {
        url: 'getArticleCateList',
        type: 'get',
        comment: '文章分类',
    },
    getArticleList: {
        url: 'getArticleList',
        type: 'get',
        comment: '文章列表',
    },

    article: {
        url: 'Login/article',
        type: 'post',
        comment: 'article',
    },
    articleinfo: {
        url: 'article/articleinfo',
        type: 'post',
        comment: 'articleinfo',
    },
    like: {
        url: 'article/like',
        type: 'post',
        comment: 'like',
    },
    getAward: {
        url: 'article/getAward',
        type: 'post',
        comment: 'getAward',
    },
    shareArc: {
        url: 'article/shareArc',
        type: 'get',
        comment: '内容分享列表-分享资讯',
    },
    myArc: {
        url: 'article/myArc',
        type: 'post',
        comment: 'myArc',
    },

    myArticle: {
        url: 'article/myArticle',
        type: 'post',
        comment: 'myArticle',
    },

    myArcUser: {
        url: 'article/myArcUser',
        type: 'post',
        comment: 'myArcUser',
    },

    readyList: {
        url: 'article/readyList',
        type: 'post',
        comment: 'readyList',
    },

    cellect: {
        url: 'article/cellect',
        type: 'post',
        comment: 'cellect',
    },

    comList: {
        url: 'article/comList',
        type: 'post',
        comment: 'comList',
    },

    comment: {
        url: 'article/comment',
        type: 'post',
        comment: 'comment',
    },

    comLike: {
        url: 'article/comLike',
        type: 'post',
        comment: 'comLike',
    },

    replyCom: {
        url: 'article/replyCom',
        type: 'post',
        comment: 'replyCom',
    },


    updateUserInfo: {
        url: 'updateUserInfo',
        type: 'post',
        comment: 'updateUserInfo',
    },

    uploadThumb: {
        url: 'uploadThumb',
        type: 'post',
        comment: '上传头像',
    },

    saveThumb: {
        url: 'saveThumb',
        type: 'post',
        comment: '保存头像',
    },

    updatePassword: {
        url: 'updatePassword',
        type: 'post',
        comment: '修改密码',
    },

    setPassword: {
        url: 'user/setPassword',
        type: 'post',
        comment: 'setPassword',
    },

    Addr: {
        url: 'user/Addr',
        type: 'post',
        comment: 'Addr',
    },

    createAddr: {
        url: 'user/createAddr',
        type: 'post',
        comment: 'createAddr',
    },

    getAddr: {
        url: 'user/getAddr',
        type: 'post',
        comment: 'getAddr',
    },

    editAddr: {
        url: 'user/editAddr',
        type: 'post',
        comment: 'editAddr',
    },

    delAddr: {
        url: 'user/delAddr',
        type: 'post',
        comment: 'delAddr',
    },

    checkPasswd: {
        url: 'user/checkPasswd',
        type: 'post',
        comment: 'checkPasswd',
    },

    userIntegral: {
        url: 'user/integral',
        type: 'post',
        comment: 'integral',
    },

    integralList: {
        url: 'user/integralList',
        type: 'post',
        comment: 'integralList',
    },

    exchangeGift: {
        url: 'user/exchangeGift',
        type: 'post',
        comment: 'exchangeGift',
    },

    giftlists: {
        url: 'user/giftlist',
        type: 'post',
        comment: 'giftlist',
    },

    giftInfo: {
        url: 'user/giftInfo',
        type: 'post',
        comment: 'giftInfo',
    },

    integralRecord: {
        url: 'user/integralRecord',
        type: 'post',
        comment: 'integralRecord',
    },

    integralConvertMoney: {
        url: 'user/integralConvertMoney',
        type: 'post',
        comment: 'integralConvertMoney',
    },

    scoreToMoney: {
        url: 'user/scoreToMoney',
        type: 'post',
        comment: 'scoreToMoney',
    },

    prize: {
        url: 'user/prize',
        type: 'post',
        comment: '抽奖大转盘详情',
    },

    prizeRecord: {
        url: 'user/prizeRecord',
        type: 'post',
        comment: 'prizeRecord',
    },

    drawPrize: {
        url: 'user/drawPrize',
        type: 'post',
        comment: 'drawPrize',
    },

    prizeInfo: {
        url: 'user/prizeInfo',
        type: 'post',
        comment: 'prizeInfo',
    },


    money: {
        url: 'user/money',
        type: 'post',
        comment: 'money',
    },

    moneyList: {
        url: 'user/moneyList',
        type: 'post',
        comment: 'moneyList',
    },

    cashMoney: {
        url: 'user/cashMoney',
        type: 'post',
        comment: 'cashMoney',
    },

    consumptionRec: {
        url: 'user/consumption',
        type: 'post',
        comment: 'consumptionRec',
    },

    moneyRecord: {
        url: 'user/moneyRecord',
        type: 'post',
        comment: 'moneyRecord',
    },

    awardRecord: {
        url: 'user/awardRecord',
        type: 'post',
        comment: 'awardRecord',
    },

    CommissionTop: {
        url: 'user/CommissionTop',
        type: 'post',
        comment: 'CommissionTop',
    },

    myTeam: {
        url: 'user/myTeam',
        type: 'post',
        comment: 'myTeam',
    },

    teamList: {
        url: 'user/teamList',
        type: 'post',
        comment: 'teamList',
    },

    teamTop: {
        url: 'user/teamTop',
        type: 'post',
        comment: 'teamTop',
    },

    uploadCard: {
        url: 'user/uploadCard',
        type: 'post',
        comment: 'uploadCard',
    },

    saveCard: {
        url: 'user/saveCard',
        type: 'post',
        comment: 'saveCard',
    },

    award: {
        url: 'user/award',
        type: 'post',
        comment: 'award',
    },

    cellectCourse: {
        url: 'user/collectCourse',
        type: 'post',
        comment: 'collectCourse',
    },

    cancelCourse: {
        url: 'user/cancelCourse',
        type: 'post',
        comment: 'cancelCourse',
    },

    cellectArc: {
        url: 'article/arcCollect',
        type: 'post',
        comment: 'arcCollect',
    },

    cancelArc: {
        url: 'article/cancelArc',
        type: 'post',
        comment: 'cancelArc',
    },

    myVoteList: {
        url: 'vote/myVoteList',
        type: 'post',
        comment: 'myVoteList',
    },

    myVoteInfo: {
        url: 'vote/myVoteInfo',
        type: 'post',
        comment: 'myVoteInfo',
    },

    searchUser: {
        url: 'vote/searchUser',
        type: 'post',
        comment: 'searchUser',
    },

    myVoteUser: {
        url: 'vote/myVoteUser',
        type: 'post',
        comment: 'myVoteUser',
    },

    myVote: {
        url: 'vote/myVote',
        type: 'post',
        comment: 'myVote',
    },

    voteForm: {
        url: 'vote/voteForm',
        type: 'post',
        comment: 'voteForm',
    },

    voteList: {
        url: 'vote/voteList',
        type: 'post',
        comment: 'voteList',
    },

    voteInfo: {
        url: 'vote/voteInfo',
        type: 'post',
        comment: 'voteInfo',
    },

    voteUser: {
        url: 'vote/voteUser',
        type: 'post',
        comment: 'voteUser',
    },

    voteTop: {
        url: 'vote/voteTop',
        type: 'post',
        comment: 'voteTop',
    },

    searchTop: {
        url: 'vote/searchTop',
        type: 'post',
        comment: 'searchTop',
    },

    searchUsers: {
        url: 'vote/searchUsers',
        type: 'post',
        comment: 'searchUsers',
    },

    voteCode: {
        url: 'vote/voteCode',
        type: 'post',
        comment: 'voteCode',
    },

    vote: {
        url: 'vote/vote',
        type: 'post',
        comment: 'vote',
    },

    image: {
        url: 'vote/uploadImage',
        type: 'post',
        comment: 'vote',
    },

    video: {
        url: 'vote/video',
        type: 'post',
        comment: 'video',
    },

    bmTime: {
        url: 'vote/bmTime',
        type: 'post',
        comment: 'video',
    },

    bmVote: {
        url: 'vote/bmVote',
        type: 'post',
        comment: 'bmVote',
    },


    getIndexData: {
        url: 'getIndexData',
        type: 'get',
        comment: '首页数据',
    },

    sendArticleLike: {
        url: 'sendArticleLike',
        type: 'post',
        comment: '文章点赞',
        data: {
            aid: '文章ID'
        }
    },

    sendArticleCommentLike: {
        url: 'sendArticleCommentLike',
        type: 'post',
        comment: '评论点赞',
        data: {
            aid: '评论ID'
        }
    },
    sendArticleCollect: {
        url: 'sendArticleCollect',
        type: 'post',
        comment: '收藏文章',
        data: {
            aid: '文章ID'
        }
    },
    getArticleReadMany: {
        url: 'getArticleReadMany',
        type: 'get',
        comment: '阅读人数列表',
        data: {
            aid: '文章ID',
            page: '页数',
            limit: '每页显示条数',
            group: '是否去重',
        }
    },
    articleTransmitEarnings: {
        url: 'articleTransmitEarnings',
        type: 'post',
        comment: '获得文章转发首页',
        data: {
            aid: '文章ID',
            shareid: '分享人ID',
        }
    },
    getUserReadCountForArticle: {
        url: 'getUserReadCountForArticle',
        type: 'get',
        comment: '获取文章浏览用户数量',
        data: {
            aid: '文章ID',
        }
    },

    getComplainList: {
        url: 'getComplainList',
        type: 'get',
        comment: '投诉建议',
        data: {
            page: '页码',
            limit: '条数',
        }
    },

    getEnrollCourse: {
        url: 'getEnrollCourse',
        type: 'get',
        comment: '预约报名-课程列表',
        data: {}
    },

    getEnrollSys: {
        url: 'getEnrollSys',
        type: 'get',
        comment: '预约报名-报考列表',
        data: {}
    },

    getEnrollEvent: {
        url: 'getEnrollEvent',
        type: 'get',
        comment: '预约报名-活动列表',
        data: {}
    },

    getTrainPending: {
        url: 'getTrainPending',
        type: 'get',
        comment: '培训中心-待审核',
        data: {}
    },

    getTrainUnderway: {
        url: 'getTrainUnderway',
        type: 'get',
        comment: '培训中心-进行中',
        data: {}
    },

    getTrainFinished: {
        url: 'getTrainFinished',
        type: 'get',
        comment: '培训中心-已完成',
        data: {}
    },


    ShareCourse: {
        url: 'ShareCourse',
        type: 'get',
        comment: '内容分享列表-分享课程',
        data: {
            page: '页码',
            limit: '条数',
        }
    },

    Refund: {
        url: 'Refund',
        type: 'post',
        comment: '我的订单-退款',
        data: {
            order: '订单id',
            content: '退款内容',
        }
    },

    sendCourseComment: {
        url: 'sendCourseComment',
        type: 'post',
        comment: '我的订单-评论',
        data: {
            cid: '订单id',
            type: '课程类型',
            limit: '评论内容',
        }
    },

    search: {
        url: 'search',
        type: 'post',
        comment: '首页-搜索',
        data: {
            cid: '订单id',
            type: '课程类型',
            content: '评论内容',
            page: '页码',
        }
    },

    getTeacherCate: {
        url: 'getTeacherCate',
        type: 'get',
        comment: '教师列表-分类',
        data: {}
    },

    getTeacherList: {
        url: 'getTeacherList',
        type: 'get',
        comment: '教师列表-分类',
        data: {
            cid: '教师分类id',
            page: '页码',
            limit: '条数',
        }
    },
    createOrderForExam: {
        url: 'createOrderForExam',
        type: 'post',
        comment: '购买试卷',
        data: {}
    },
    upExamPaper: {
        url: 'upExamPaper',
        type: 'post',
        comment: '交卷',
        data: {}
    },
    rePaper: {
        url: 'rePaper',
        type: 'post',
        comment: '重做试卷',
        data: {}
    },
    sendNotepad: {
        url: 'sendNotepad',
        type: 'post',
        comment: '发送我的笔记',
        data: {}
    },
    getNotepad: {
        url: 'getNotepad',
        type: 'post',
        comment: '获取笔记',
        data: {}
    },
    sendCourseAsk: {
        url: 'sendCourseAsk',
        type: 'post',
        comment: '发送我的提问',
        data: {}
    },
    getCourseAsk: {
        url: 'getCourseAsk',
        type: 'post',
        comment: '获取提问',
        data: {}
    },
    QuestionnaireList: {
        url: 'QuestionnaireList',
        type: 'get',
        comment: '问卷调查列表',
        data: {}
    },
    QuestionnaireDetails: {
        url: 'QuestionnaireDetails',
        type: 'get',
        comment: '问卷调查表单',
        data: {}
    },
    QuestionnaireAdd: {
        url: 'QuestionnaireAdd',
        type: 'post',
        comment: '提交问卷调查表单',
        data: {}
    },
    getQuestionRanking: {
        url: 'getQuestionRanking',
        type: 'get',
        comment: '获取排行榜',
        data: {}
    },


    getMyBuyCourseAllNumber: {
        url: 'getMyBuyCourseAllNumber',
        type: 'get',
        comment: '学习报告课程统计',
        data: {}
    },

    getMyBuyCourseOnline: {
        url: 'getMyBuyCourseOnline',
        type: 'get',
        comment: '学习报告直播统计',
        data: {}
    },
    getMyBuyCourseWebcam: {
        url: 'getMyBuyCourseWebcam',
        type: 'get',
        comment: '学习报告点播统计',
        data: {}
    },
    getTheUserQuestionRanking: {
        url: 'getTheUserQuestionRanking',
        type: 'get',
        comment: '获取我关于题库的击败比',
        data: {}
    },
    getTheUserQuestionNumberDetail: {
        url: 'getTheUserQuestionNumberDetail',
        type: 'get',
        comment: '获取关于题库的练习数量',
        data: {}
    },
    getTheUserAboutQuestion: {
        url: 'getTheUserAboutQuestion',
        type: 'get',
        comment: '获取用户关于当前分类的做题排行',
        data: {}
    },
    getTestRecords: {
        url: 'getTestRecords',
        type: 'get',
        comment: '练习记录考试记录',
        data: {}
    },
    getPracticeTest: {
        url: 'getPracticeTest',
        type: 'get',
        comment: '获取模考列表',
        data: {
            cid: '分类ID'
        }
    },
    getPracticeTestDetail: {
        url: 'getPracticeTestDetail',
        type: 'get',
        comment: '获取模考详情',
        data: {
            mid: '模考ID'
        }
    },

    BargainList: {
        url: 'BargainList',
        type: 'get',
        comment: '砍价列表',
        data: {
            page: '页数',
            limit: '条数'
        }
    },

    BargainDetails: {
        url: 'BargainDetails',
        type: 'get',
        comment: '砍价详情',
        data: {
            bid: '砍价详情页ID',
            pid: '分享人ID',
        }
    },

    BargainEnd: {
        url: 'BargainEnd',
        type: 'get',
        comment: '砍价历史',
        data: {
            page: '页数',
            limit: '条数',
        }
    },

    BargainAdd: {
        url: 'BargainAdd',
        type: 'post',
        comment: '提交砍价',
        data: {
            bid: '砍价详情页ID',
            pid: '帮谁砍价',
        }
    },

    payDetails: {
        url: 'payDetails',
        type: 'get',
        comment: '砍价、订金、拼团订单',
        data: {
            courseid: '购买的课程ID',
            pid: '分享人ID',
            type: '类型',
        }
    },

    createCourseOrders: {
        url: 'createCourseOrders',
        type: 'post',
        comment: '提交砍价、拼团、订金订单',
        data: {
            uid: '用户ID',
            giveYue: '用户提交的想要用余额支付的金额',
            threePaymentType: ' 第三方支付类型',
            type: '课程类型',
            cid: ' 课程ID',
            tuid: '推荐人ID',
            aid: '收货地址ID',
            device: '支付终端',
            payToType: '支付环境类型',
            openId: 'openId',
        }
    },

    GroupList: {
        url: 'GroupList',
        type: 'get',
        comment: '拼团列表',
        data: {
            page: '页数',
            limit: '条数',
        }
    },

    GroupDetails: {
        url: 'GroupDetails',
        type: 'get',
        comment: '拼团详情',
        data: {
            gid: '拼团id',
            pid: '分享人id',
        }
    },

    GroupCourseDetails: {
        url: 'GroupCourseDetails',
        type: 'get',
        comment: '课程详情页拼团列表',
        data: {
            type: '课程类型id',
            courseid: '课程id',
            page: '页数',
            limit: '条数',
        }
    },

    GroupEnd: {
        url: 'GroupEnd',
        type: 'get',
        comment: '拼团历史',
        data: {
            page: '页数',
            limit: '条数',
        }
    },

    PersonageCourseOrder: {
        url: 'PersonageCourseOrder',
        type: 'get',
        comment: '砍价订单',
        data: {
            type: '类型',
            ctype: '分类',
            page: '页数',
            limit: '条数',
        }
    },

    CourseOrderAuditFile: {
        url: 'CourseOrderAuditFile',
        type: 'post',
        comment: '上传图片',
        data: {
            image: '图片',
        }
    },

    CourseOrderAudit: {
        url: 'CourseOrderAudit',
        type: 'post',
        comment: '提交线下支付凭证',
        data: {
            oid: '订单id',
            image: '图片',
            content: '备注',
            wid: '审核的id',
        }
    },

    zwList: {
        url: 'Zw/zwList',
        type: 'post',
        comment: '我的占座列表',
        data: {
            order_id: '订单id',
        }
    },

    ZwCourseList: {
        url: 'Zw/courseList',
        type: 'get',
        comment: '占座列表',
        data: {
            order_id: '购买课程订单的ID',
        }
    },
    bjList: {
        url: 'Zw/bjList',
        type: 'get',
        comment: '班级列表',
        data: {
            course_id: '购买课程的ID',
        }
    },
    zwInfo: {
        url: 'Zw/zwInfo',
        type: 'get',
        comment: '座位详情',
        data: {
            class_id: '班级的ID',
        }
    },
    selectZw: {
        url: 'Zw/selectZw',
        type: 'post',
        comment: '执行占座',
        data: {
            id: '当做座位ID',
            zw: '座位信息',
            course_id: '购买课程ID',
        }
    },

    getEduClock: {
        url: 'getEduClock',
        type: 'get',
        comment: '获取考试倒计时',
        data: {
            cid: '分类ID'
        }
    },
    //新增
    drawList: {
        url: 'User/drawList',
        type: 'get',
        comment: '抽奖列表',
        data: {
            limit: '限制条数,默认15',
            page: "页码"
        }
    },
    prizeService: {
        url: 'User/prizeService',
        type: 'get',
        comment: '抽奖客服',
        data: {
            prize_id: "抽奖活动id"
        }
    },

    getDefaultAddress: {
        url: 'getDefaultAddress',
        type: 'get',
        comment: '获取默认收货地址',
        data: {}
    },

    mockSign: {
        url: 'mockSign',
        type: 'post',
        comment: '模考报名',
        data: {
            mid: '模考Id'
        }
    },

    payment: {
        url: 'payment',
        type: 'get',
        comment: '立即支付订单页面详情',
        data: {
            oid: '订单id',
            type: '1:立即支付，2:定金尾款',
        }
    },

    createCourseOrderPayment: {
        url: 'createCourseOrderPayment',
        type: 'post',
        comment: '立即支付订单提交',
        data: {
            oid: '订单id',
            giveYue: '用户提交的想要用余额支付的金额',
            threePaymentType: ' 第三方支付类型',
            type: '1:立即支付，2:定金尾款',
            device: '支付终端',
            payToType: '支付环境类型',
            openId: 'openId',
        }
    },

    getCoupon: {
        url: 'getCoupon',
        type: 'post',
        comment: '领取优惠券',
        data: {
            couponid: '优惠劵id',
            courseid: '课程id',
            type: '课程类型',
        }
    },

    getNotice: {
        url: 'getNotice',
        type: 'get',
        comment: '个人中心通知',
        data: {}
    },
    getPos: {
        url: 'getPos',
        type: 'get',
        comment: '个人中心广告',
        data: {}
    },

    getMyApply: {
        url: 'getMyApply',
        type: 'get',
        comment: '培训中心获取我的培训',
        data: {}
    },

    //作业圈打卡
    getDkList: {
        url: "Dk/index",
        type: 'get',
        comment: "打卡列表",
        data: {
            "page": '页码',
            "limit": "每页显示条数"
        }
    },
    getMyDk: {
        url: 'Dk/myDk',
        type: 'get',
        data: {
            "page": '页码',
            "limit": "每页显示条数"
        }
    },
    toBm: {
        url: "Dk/toBm",
        type: "post",
        data: {
            "username": "用户名",
            "phone": "用户手机号",
            "code": "验证码",
            "vid": "打卡活动ID"
        }
    },
    getCode: {
        url: "Dk/sendSms",
        type: "post",
        data: {
            "phone": "用户手机号码"
        }
    },
    dkInfo: {
        url: 'Dk/info',
        type: 'get',
        data: {
            "vid": "打卡活动id"
        }
    },
    themeList: {
        url: 'Dk/themeList',
        type: 'get',
        data: {
            "vid": "打卡活动id"
        }
    },
    themeInfo: {
        url: 'Dk/themeInfo',
        type: "get",
        data: {
            "vid": "打卡活动id",
            "theme_id": "主题id"
        }
    },
    toDk: {
        url: 'Dk/toDk',
        type: "post",
        data: {
            "vid": "打卡活动id",
            "theme_id": "主题id"
        }
    },
    dkForm: {
        url: 'Dk/dkForm',
        type: "post",
        data: {
            "vid": "打卡活动id",
            "theme_id": "主题id",
            "content": "打卡内容",
            "pic": "图片",
            "video": "视频",
            "audio": "语音",
            "share_id": "分享人的id"
        }
    },
    dkUpload: {
        url: "Dk/upload",
        type: "post",
        data: {
            "file": "上传文件|图片|视频|语音"
        }
    },
    dkList: {
        url: "Dk/dkList",
        type: "get",
        data: {
            "vid": "打卡活动id",
            "theme_id": "主题id"
        }
    },
    getLike: {
        url: 'Dk/like',
        type: "get",
        data: {
            "vid": "打卡活动id",
            "theme_id": "主题id",
            "dk_user_id": "打卡人的ID"
        }
    },
    toDayTask: {
        url: 'Dk/toDayTask',
        type: "get",
    },
    commonInfo: {
        url: "Dk/commonInfo",
        type: "get",
        data: {
            "vid": "打卡活动id",
            "theme_id": "主题id",
            "dk_user_id": "打卡人的ID"
        }
    },
    replyDk: {
        url: 'Dk/reply',
        type: "post",
        data: {
            "vid": "打卡活动id",
            "theme_id": "主题id",
            "reply_user_id": "打卡人的ID",
            "content": '回复内容'
        }
    },
    replyDkList: {
        url: 'Dk/replyList',
        type: "get",
        data: {
            "vid": "打卡活动id",
            "theme_id": "主题id",
            "dk_user_id": "打卡人的ID",
        }
    },
    menu: {
        url: "menu",
        type: "get",
    },
    updatePayOpenId: {
        url: 'updatePayOpenId',
        type: "post",
    },
    openingFreeCourse: {
        url: 'openingFreeCourse',
        type: "post",
    },

    Look: {
        url: 'Look',
        type: "get",
        comment: '看图答题页面数据接口',
        data: {
            "type": "游戏的类别",
        }
    },
    LookAdd: {
        url: 'LookAdd',
        type: "post",
        comment: '看图答题页面数据接口',
        data: {
            "type": "游戏的类别",
            "tuid": "推荐人ID",
            "title": "游戏名称",
            "start_time ": "活动开始时间",
            "end_time": "活动结束时间",
            "activity_score": "抽奖门槛（多少分可以抽奖）",
            "score": "福卡类别（仅在集福卡活动中需要传值，其他不存在此字段）",
            "neck": "判断是否领取了福卡（仅在集福卡活动中需要传值，其他不存在此字段）",
        }
    },
    LookUserAdd: {
        url: 'LookUserAdd',
        type: "post",
        comment: '判断是否为新用户',
        data: {
            "type": "游戏的类别",
        }
    },
    lookTopicAdd: {
        url: 'lookTopicAdd',
        type: "post",
        comment: '提交答案',
        data: {
            "id": "游戏ID",
            "count": "是否为最后一次提交",
            "data": "题目Id、分数、答案、答题时长",
        }
    },
    LookPrizeInformation: {
        url: 'LookPrizeInformation',
        type: "get",
        comment: '获取奖品信息',
        data: {
            "type": "游戏的类别",
            "id": "是否抽奖",
        }
    },
    LookPrizeCollect: {
        url: 'LookPrizeCollect',
        type: "post",
        comment: '用户开奖',
        data: {
            "id": "添加奖品记录的ID",
        }
    },
    rankingList: {
        url: 'rankingList',
        type: "get",
        comment: '获取排行榜',
        data: {
            "type": "游戏的类别",
            "aid": "奖品下标",
        }
    },
    LookUserMessageAdd: {
        url: 'LookUserMessageAdd',
        type: "post",
        comment: '登记领奖表单提交',
        data: {
            "type": "游戏的类别",
            "phone": "电话",
            "name": "姓名",
            "code": "验证码",
        }
    },
    LookPhone: {
        url: 'LookPhone',
        type: "post",
        comment: '登记领奖表单手机号码提交',
        data: {
            "phone": "电话",
        }
    },
    LookPrizeList: {
        url: 'LookPrizeList',
        type: "get",
        comment: '获取中奖纪录',
        data: {
            "type": "游戏的类别",
            "limit": "条数",
            "page": "页码",
        }
    },
    LookPrizeListDetails: {
        url: 'LookPrizeListDetails',
        type: "get",
        comment: '获取中奖纪录奖品详情',
        data: {
            "id ": "奖品ID",
            "type ": "游戏类型",
        }
    },
    LookUid: {
        url: 'LookUid',
        type: "get",
        comment: '获取分享人信息',
        data: {
            "tuid": "推荐人的ID",
        }
    },
    LookCaptainList: {
        url: 'LookCaptainList',
        type: "get",
        comment: '获取好友助力情况',
        data: {
            "type": "游戏类型",
            "page": "页码",
            "limit": "条数",
        }
    },
    LookHelpList: {
        url: 'LookHelpList',
        type: "get",
        comment: '获取帮忙助力；列表',
        data: {
            "type": "游戏类型",
            "page": "页码",
            "limit": "条数",
        }
    },
    LookCarryPrize: {
        url: 'LookCarryPrize',
        type: "get",
        comment: '集福卡获奖信息轮播',
        data: {
            "type": "游戏类型",
        }
    },
    FriendHelpList: {
        url: 'FriendHelpList',
        type: "get",
        comment: '好友助力排行',
        data: {
            'tuid': '推荐人ID',
            'page': '页码',
            'limit': '条数',
        }
    },
    FriendHelp: {
        url: 'FriendHelp',
        type: "get",
        comment: '获取助力页面信息',
        data: {
            'tuid': '推荐人ID',
        }
    },
    UserAttention: {
        url: 'UserAttention',
        type: "get",
        comment: '是否关注了公众号',
        data: {}
    },

    //-----------------------fei----------------------

    playGameInfo: {
        url: "PlayGame/info",
        type: "get",
        data: {
            "vid": '游戏类型id'
        }
    },
    playGameMyPrize: {
        url: "PlayGame/myPrize",
        type: "get",
        data: {
            "vid": '游戏类型id',
            "page": "页数",
            "limit": "限制条数"
        }
    },
    playGameDrawPrize: {
        url: "PlayGame/drawPrize",
        type: "get",
        data: {
            "vid": '游戏类型id'
        }
    },
    PlayGameGetWard: {
        url: "PlayGame/getWard",
        type: "post",
        data: {
            "username": "用户名",
            "phone": "手机号码",
            "code": "验证码",
            "user_log_id": "中奖id",
            "vid": "游戏vid"
        }
    },
    playGameSms: {
        url: "PlayGame/sendSms",
        type: "get",
        data: {
            "phone": "手机号码"
        }
    },
    playGameTobm: {
        url: "PlayGame/toBm",
        type: "post",
        data: {
            "username": "用户名",
            "phone": "手机号码",
            "code": "验证码",
            "vid": "游戏id"
        }
    },
    playGamePrizeInfo: {
        url: "PlayGame/prizeInfo",
        type: "get",
        data: {
            "prizeLogId": "中奖纪录id",
            "vid": "游戏id"
        }
    },

    // 打开红包
    playGameOpenMoney: {
        url: "PlayGame/openMoney",
        type: "get",
        data: {
            "pvid": "是否有发起人的id",
            "vid": "游戏id"
        }
    },
    // 瓜分红包 playGameSplitMoney
    playGameSplitMoney: {
        url: "PlayGame/splitMoney",
        type: "get",
        data: {
            "pvid": "是否有发起人的id",
            "vid": "游戏id"
        }
    },

    // 掌刮男朋友
    playGamePassBoy: {
        url: "PlayGame/passBoy",
        type: "get",
        data: {
            "vid": '游戏类型id',
            "score": '游戏分数'
        }
    },
    playGameDrawBoy: {
        url: "PlayGame/drawBoy",
        type: "get",
        data: {
            "vid": '游戏类型id',
        }
    },
    playGameBoyRank: {
        url: "PlayGame/boyRank",
        type: "get",
        data: {
            "score": '分数',
        }
    },
    updateVideoTime: {
        url: "updateVideoTime",
        type: "post",
        data: {}
    },
    getVideoInfo: {
        url: "getVideoInfo",
        type: "post",
        data: {}
    },
    sendExamError: {
        url: "sendExamError",
        type: "post",
        data: {}
    },
    saveExamExperience: {
        url: "saveExamExperience",
        type: "post",
        data: {}
    },


    /*----------新题库接口开始----------*/
    exam: {
        url: "exam",
        type: "get",
        comment: '获取题库首页信息',
        data: {
            'cate_id': '考试科目id(默认不传id)',
        }
    },
    getExamClassifyList: {
        url: "exam/cate/list",
        type: "get",
        comment: '获取分类+指定分类（大类）',
        data: {
            "cid": '考试科目id(默认不传id)',
        }
    },
    getExamUpdate: {
        url: "exam/cate/update",
        type: "get",
        comment: '绑定最后选择分类',
        data: {
            "cid": '考试科目id(默认不传id)',
        }
    },
    getMockList: {
        url: "exam/mock/list",
        type: "get",
        comment: '模拟套卷列表',
        data: {
            "cf_id": '考试科目id',
            "page": '列表页数',
        }
    },

    getZtList: {
        url: "exam/zt",
        type: "get",
        comment: '历年真题',
        data: {
            "cf_id": '考试科目id',
            "page": '列表页数',
        }
    },
    getPayFree: {
        url: "exam/mock/payFree",
        type: "get",
        comment: '免费套卷创建订单',
        data: {
            "sid": '套卷id',
        }
    },
    getTopic: {
        url: "exam/mock/topic",
        type: "get",
        comment: '获取模拟套卷详情',
        data: {
            "sid": '套卷id',
        }
    },
    getZtTopic: {
        url: "exam/zt/topic",
        type: "get",
        comment: '获取历年真题详情',
        data: {
            "sid": '套卷id',
        }
    },
    getExamKnow: {
        url: "exam/know",
        type: "get",
        comment: '题库首页点击我知道了',
        data: {}
    },
    getMockCheckPaper: {
        url: "exam/mock/checkPaper",
        type: "get",
        comment: '模考套卷查询是否提交',
        data: {
            "sid": '套卷id',
        }
    },
    mockReform: {
        url: "exam/mock/reform",
        type: "get",
        comment: '未做完，重做',
        data: {
            "sid": '套卷id',
        }
    },
    activeBm: {
        url: "exam/active/bm",
        type: "get",
        comment: '模考报名',
        data: {
            "mid": '模考id',
            "cf_id": '试卷分类id',
        }
    },
    getExamActive: {
        url: "exam/active",
        type: "get",
        comment: '获取模考专题列表',
        data: {
            "sid": '考试顶级分类id',
            "page": '页码',
        }
    },

    activeActive: {
        url: "exam/active/topic",
        type: "get",
        comment: '模考大纲',
        data: {
            'id': '模考id',
        }
    },

    activeDetail: {
        url: "exam/active/detail",
        type: "get",
        comment: '模考详情',
        data: {
            'id': '模考id',
        }
    },

    getMockSave: {
        url: "exam/mock/save",
        type: "post",
        comment: '单选题提交答案',
        data: {
            "pid": '阅读分析小题父级ID，阅读分析必填',
            "qid": '试题id',
            "answer": '答案',
            "cf_id": '分类id',
            "type": '单选题',
            "sid": '试卷记录id',
            "cp_id": '章节id',
            "mid": '模考id',
            "answer_id": '答案id',
        }
    },
    getSaveAnswer: {
        url: "exam/mock/saveAnswer",
        type: "post",
        comment: '阅读分析题提交答案',
        data: [{
            "pid": '模拟套卷阅读分析小题父级ID，阅读分析必填',
            "qid": '试题id',
            "answer": '答案',
            "cf_id": '分类id',
            "type": '单选题',
            "sid": '试卷记录id',
            "cp_id": '章节id',
            "mid": '模考id',
            "answer_id": '答案id',
        }]
    },

    chapterSaveAnswer: {
        url: "exam/chapter/saveAnswer",
        type: "get",
        comment: '章节练习随机练习保存答案',
        data: {
            'id': '阅读分析题目id',
            'qt_id': '阅读分析题目类型',
            'formData':{
                "pid": '阅读分析小题父级ID，阅读分析必填',
                "qid": '试题id',
                "answer": '答案',
                "cf_id": '分类id',
                "type": '单选题',
                "sid": '试卷记录id',
                "cp_id": '章节id',
                "mid": '模考id',
            }
        }
    },

    getCollectLike: {
        url: "exam/collect/like",
        type: "get",
        comment: '收藏试题',
        data: {
            "type": '1、模拟套卷；2、历年真题；3、随机练习；4、每日一练,5、章节练习',
            "record_id": '试卷记录id',
            "qid": '题目id',
            "cate_id": '分类id',
            "collect_id": '如果已经标记，需要传值',
        }
    },
    getCollectTag: {
        url: "exam/collect/tag",
        type: "get",
        comment: '标记试题',
        data: {
            "qid": '试题id',
            "rid": '试卷记录id',
            "sid": '试卷id',
            "id": '如果已经标记，需要传值',
        }
    },
    getMistakeAdd: {
        url: "exam/mistake/add",
        type: "post",
        comment: '加入纠错',
        data: {
            "question_id": '题目id',
            "type": '纠错类型',
            "error_content": '纠错问题',
            "true_content": '正确信息',
        }
    },
    savePage: {
        url: "exam/mock/savePage",
        type: "get",
        comment: '提交模拟试卷',
        data: {
            "sid": '试卷id',
        }
    },
    mockReport: {
        url: "exam/mock/report",
        type: "get",
        comment: '模拟套卷报告',
        data: {
            "sid": '试卷id',
            "sj_record_id": '试卷记录id',
        }
    },
    mockHarvest: {
        url: "exam/mock/harvest",
        type: "post",
        comment: '提交考试心得',
        data: {
            "id": '试卷记录的id',
            "comment": '提交心得内容',
        }
    },
    mockHarvestList: {
        url: "exam/mock/harvest/list",
        type: "get",
        comment: '考试心得',
        data: {
            'page': ''
        }
    },

    getMockCorrectList: {
        url: "exam/mock/correct/list",
        type: "get",
        comment: '纠错记录列表',
        data: {
            "page": '页数',
        }
    },

    mockRepaper: {
        url: "exam/mock/repaper",
        type: "get",
        comment: '重做试卷',
        data: {
            "sid": '试卷id',
        }
    },

    random: {
        url: "exam/random",
        type: "get",
        comment: '随机练习',
        data: {
            'cf_id': '分类id'
        }
    },

    daily: {
        url: "exam/daily",
        type: "get",
        comment: '每日一练',
        data: {
            'cf_id': '分类id'
        }
    },

    chapterExam: {
        url: "exam/chapter/exam",
        type: "get",
        comment: '章节练习',
        data: {
            'id': '章节id',
            'cf_id': '分类id'
        }
    },

    chapterSave: {
        url: "exam/chapter/save",
        type: "get",
        comment: '章节练习保存答案',
        data: {
            "pid": '阅读分析小题父级ID，阅读分析必填',
            "qid": '试题id',
            "answer": '答案',
            "cf_id": '分类id',
            "type": '单选题',
            "sid": '试卷记录id',
            "cp_id": '章节id',
            "mid": '模考id',
        }
    },

    chapter: {
        url: "exam/chapter",
        type: "get",
        comment: '章节练习列表',
        data: {
            'page': '页数',
            'cf_id': '分类id',
            'id': '章节id，存在下一级传递该值',
        }
    },

    randomSave: {
        url: "exam/random/save",
        type: "post",
        comment: '随机练习保存答案',
        data: {
            "pid": '阅读分析小题父级ID，阅读分析必填',
            "qid": '试题id',
            "answer": '答案',
            "cf_id": '分类id',
            "type": '单选题',
            "sid": '试卷记录id',
            "cp_id": '章节id',
            "mid": '模考id',
            "rid": '随机练习记录id',
        }
    },

    randomSaveAnswer: {
        url: "exam/random/saveAnswer",
        type: "post",
        comment: '随机练习阅读分析保存答案',
        data: {
            "pid": '阅读分析小题父级ID，阅读分析必填',
            "qid": '试题id',
            "answer": '答案',
            "cf_id": '分类id',
            "type": '单选题',
            "sid": '试卷记录id',
            "cp_id": '章节id',
            "mid": '模考id',
            "rid": '随机练习记录id',
        }
    },

    randomSavePage: {
        url: "exam/random/savePage",
        type: "get",
        comment: '随机练习提交试卷',
        data: {
            "rid": '随机练习记录id',
        }
    },

    dailySavePage: {
        url: "exam/daily/savePage",
        type: "get",
        comment: '每日一练提交试卷',
        data: {
            "did": '每日一练记录id',
        }
    },

    dailyMistake: {
        url: "exam/daily/mistake",
        type: "get",
        comment: '每日一练解析页面',
        data: {
            "did": '每日一练记录id',
        }
    },

    randomReport: {
        url: "exam/random/report",
        type: "get",
        comment: '随机练习练习报告',
        data: {
            "rid": '随机练习记录id',
        }
    },

    dailyReport: {
        url: "exam/daily/report",
        type: "get",
        comment: '每日一练练习报告',
        data: {
            "rid": '随机练习记录id',
        }
    },

    mockMistake: {
        url: "exam/mock/mistake",
        type: "get",
        comment: '模拟套卷解析页面接口',
        data: {
            "sj_record_id": '随机练习记录id',
            "sid": '试卷id',
            "type": '0：全部解析；1：错题解析',
        }
    },

    randomMistake: {
        url: "exam/random/mistake",
        type: "get",
        comment: '随机练习解析页面接口',
        data: {
            "sj_record_id": '随机练习记录id',
            "sid": '试卷id',
            "type": '0：全部解析；1：错题解析',
        }
    },

    collectList: {
        url: "exam/collect",
        type: "get",
        comment: '收藏列表',
        data: {
            'page': '页码'
        }
    },

    mistakeList: {
        url: "exam/mistake/list",
        type: "get",
        comment: '错题本',
        data: {
            'page': '页码',
        }
    },

    examRank: {
        url: "exam/rank",
        type: "get",
        comment: '排行榜',
        data: {
            'cate_id': '分类id',
            'type': '1、题霸榜，2、学霸榜'
        }
    },

    examHistory: {
        url: "exam/history",
        type: "get",
        comment: '历史记录',
        data: {
            'type': '1、考试记录，2、模考记录，2、随机练习，2、每日一练',
            'page': '页码'
        }
    },

    heplerUpload: {
        url: "hepler/upload",
        type: "post",
        comment: '上传文件',
        data: {
            'file': '文件',
        }
    },

    getMockCheck: {
        url: "exam/mock/check",
        type: "get",
        comment: '查询模拟考试、历年真题是否提交过',
        data: {
            'sid': '试卷id',
        }
    },

    /*----------新题库接口结束----------*/

    /*----------个人中心准考证结束----------*/
    getUserTeacherMyExam: {
        url: "userTeacher/myExam",
        type: "get",
        comment: '准考证列表',
        data: {
            'page': '页码',
            'limit': '条数',
        }
    },
    getUserTeacherMyExamInfo: {
        url: "userTeacher/myExamInfo",
        type: "get",
        comment: '准考证详情',
        data: {
            'di': '准考证ID',
        }
    },
    getUserTeacherMyGrade: {
        url: "userTeacher/myGrade",
        type: "get",
        comment: '成绩查询列表',
        data: {
            'page': '页码',
            'limit': '条数',
        }
    },

    /*----------个人中心准考证结束----------*/
};
Vue.prototype.ApiUrl = function (api) {
    return this.Root + "/api/" + this.Apis[api].url;
};




// WEBPACK FOOTER //
// ./src/assets/api/api.js